import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import ProductsCreate from './ProductsCreate';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { createProduct } from 'store/actions/products/createProducts';
import utils from 'helpers/utils';

class ProductsCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: (response) => {
                    const { id } = response;

                    return resolve(history.push(`/products/${ id }/show`));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            resource,
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.products.actions.create') } />

                    <Actions>
                        <ListButton url='/products' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <ProductsCreate
                            { ...this.props }
                            form='products_create'
                            handleSubmitForm={ this.handleSubmitForm }
                            resource={ resource }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

ProductsCreateContainer.propTypes = {
    dispatchForm: PropTypes.func,
    history: PropTypes.object.isRequired,
    resource: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createProduct(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ProductsCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/products/create/ProductsCreateContainer.js